import React, { Component } from 'react'
import { connect } from 'react-redux';

const SET_SHARE = "SET_SHARE";

function setShare(shareModalProps) {
    const share_modal = { 
      share_category: shareModalProps.category,
      share_headline: shareModalProps.headline,
      share_subheadline: shareModalProps.subheadline,
      share_image: shareModalProps.image,
      share_link: shareModalProps.link, 
    }

    return { 
        type: SET_SHARE, 
        share_modal 
    };
}

export class ShareModalTrigger extends Component {

  render(){
    const { onButtonClick, share_modal } = this.props;

    const { category, headline, subheadline, image, headlineLink } = this.props;

    const shareModalProps = {
      category,
      headline,
      subheadline,
      image,
      link: headlineLink,
    }
  
    return (
      <i className="share-trigger open-share-dialog fa fa-share-alt" 
          aria-hidden="true" 
          data-toggle="modal" 
          data-target="#shareModal" 
          title="Teilen" 
          onClick={() => onButtonClick(shareModalProps)}>
      </i>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
      onButtonClick: (shareModalProps) => dispatch(setShare(shareModalProps))
  }
}

function mapStateToProps(state, ownProps) {
  return {
    share_modal: state.share_modal
  }
} 

export const ShareModalTriggerConnected = connect(mapStateToProps, mapDispatchToProps)(ShareModalTrigger)

export class ShareModal extends Component {
  render(){
    const { onButtonClick, share_modal } = this.props;
    let headline = share_modal.share_headline

    if(share_modal.share_category){
      headline = headline + " | " + share_modal.share_category
    }
    if(share_modal.share_subheadline){
      headline = headline + " | " + share_modal.share_subheadline
    }

    return (
        <div className="share-modal modal fade row" id="shareModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div className="share-modal__dialog modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
              <button type="button" className="share-modal__close close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <span className="share-modal__title" id="myModalLabel">Teilen</span>
                
                <div className="share-modal__share-provider">
                  <a className="share_mail"  href={`mailto:?subject=${encodeURIComponent( headline )}&body=${encodeURI(location.protocol + '//' + location.host + share_modal.share_link)}`}>
                    <i className="share-modal__share-provider-icon fa fa-envelope" aria-hidden="true"></i>
                    Email
                  </a>
                </div>

                <div className="share-modal__share-provider">
                  <a className="share_twitter" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent( headline )}${ encodeURIComponent(' - ')}${encodeURI(location.protocol + '//' + location.host + share_modal.share_link)}`} target="_blank">
                    <i className="share-modal__share-provider-icon fa fa-twitter" aria-hidden="true"></i>
                    Twitter
                  </a>
                </div>
  
                <div className="share-modal__share-provider">
                  <a className="share_facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(location.protocol + '//' + location.host + share_modal.share_link)}&title=${encodeURIComponent( headline )}&display=popup`} target="_blank">
                    <i className="share-modal__share-provider-icon fa fa-facebook-official" aria-hidden="true"></i>
                    Facebook
                  </a>
                </div>

                <div className="share-modal__share-provider">
                  <a className="share_whatsapp"  href={`whatsapp://send?text=${encodeURIComponent( headline )}${ encodeURIComponent(' - ')}${encodeURI(location.protocol + '//' + location.host + share_modal.share_link)}`} data-action="share/whatsapp/share">
                    <i className="share-modal__share-provider-icon fa fa-whatsapp" aria-hidden="true"></i>
                    Whatsapp
                  </a>
                </div>

                <img className="share-modal__image" alt={share_modal.share_title} src={share_modal.share_image} />

                <div className="sk-card__headline sk-card__headline--regular">
                  {headline}
                </div>             

                <div className="share-modal__link">{location.protocol + '//' + location.host + share_modal.share_link}</div>
              </div>            
          </div>
        </div>
      </div>
    )
  }
}

export const ShareModalConnected = connect(mapStateToProps, mapDispatchToProps)(ShareModal)